import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { CalendarIconNew } from '../../../assets/images';
import { dateFormate, getTime } from '../../../utils/utils';
import CustomizedAccordions from '../../atoms/customeAccordian';
import { MuiStack } from '../../atoms/stackComponent';
import { NoRowsOverlay } from '../../molecules/dataGridComponent';
//Customer complaint accordian in service details modal in service history
export default function ServiceDetailsCustomerComplaint(props) {
    var itemList = props.itemList;
    var _a = useState(false), showAllImages = _a[0], setShowAllImages = _a[1];
    var _b = useState(0), selectedItemIndex = _b[0], setSelectedItemIndex = _b[1];
    var _c = useState(false), viewImages = _c[0], setViewImages = _c[1];
    var handleViewAllClick = function (index) {
        setSelectedItemIndex(index);
        // setShowAllImages(true);
        setViewImages(true);
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, (itemList === null || itemList === void 0 ? void 0 : itemList.length) > 0 && (itemList === null || itemList === void 0 ? void 0 : itemList.map(function (item, index) {
        var _item$EngineerRemarks;
        return /*#__PURE__*/ React.createElement(Grid, {
            flexDirection: 'column',
            item: true,
            xs: 12,
            md: 6,
            padding: "5px 0px 5px 0px",
            key: index
        }, /*#__PURE__*/ React.createElement(CustomizedAccordions, {
            id: 'service-details-customer-complaint' + index,
            title: dateFormate(item.DocDate) + ' ' + getTime(item.DocDate),
            icon: CalendarIconNew,
            variant: "h4",
            listLength: 0,
            style: {
                backgroundColor: '#F4F7FA',
                border: '1.5px solid #DEE4EB'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                borderBottom: '1.5px solid #DEE4EB',
                paddingBottom: 0
            },
            flexDirection: 'column'
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
            id: "AdvisorComment",
            variant: "h3"
        }, item === null || item === void 0 ? void 0 : item.Complaint)), /*#__PURE__*/ React.createElement(MuiStack, {
            paddingY: 1,
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 4,
            sm: 6,
            md: 6,
            lg: 6
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                position: 'relative'
            }
        }))))), /*#__PURE__*/ React.createElement(MuiStack, {
            paddingTop: 1,
            flexDirection: "column"
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                color: '#8593A3',
                fontSize: '12px',
                fontWeight: '500'
            }
        }, t('Advisor Comments')), /*#__PURE__*/ React.createElement(Typography, {
            id: "AdvisorRemarks"
        }, (_item$EngineerRemarks = item === null || item === void 0 ? void 0 : item.EngineerRemarks) !== null && _item$EngineerRemarks !== void 0 ? _item$EngineerRemarks : "-"))));
    })), itemList.length == 0 && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'center',
        width: '100%'
    }, /*#__PURE__*/ React.createElement(NoRowsOverlay, null)));
}
